import { toast } from '@/components/toast';
import { updateSubscription as _updateSubscription } from '@/services/api';
import { logger } from '@/services/logger';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

interface Props {
    setOpen: (state: boolean) => void;
    setIsLoadingOpen: (state: boolean) => void;
    setIsConfirmationOpen?: (state: boolean) => void;
}

export const useUpdateSubscriptionAfterCancel = ({ setOpen, setIsLoadingOpen, setIsConfirmationOpen }: Props) => {
    const { mutateAsync: updateSubscription, isLoading: isUpdating } = useMutation('update-subscription', _updateSubscription, {
        onError: error => {
            if ((error as AxiosError<any>)?.response?.data?.kind === 'PlanChangeSupportNeededError') {
                toast.info({ title: "Let's talk. Please contact support to change your plan" });
            } else {
                logger.error('Failed updating subscription', error);
                toast.error({ title: 'Failed to update subscription' });
            }
            setOpen(false);
        },
        onSuccess: () => {
            setIsLoadingOpen(false);
            setIsConfirmationOpen?.(true);
        },
    });

    return { updateSubscription, isUpdating };
};
